module.exports = __webpack_public_path__ + "static/media/projects_img.63d3712b.svg";